<template>
    <div>
        <a-card type="inner" size="small">
            <a-skeleton :loading="preload" active>
                <a-form-model :form="form" :model="formData" labelAlign="left">
                    <a-divider dashed orientation="left">Form Aspek Penilaian</a-divider>

                    <a-form-model-item label="Modul">
                        <a-select v-model="formData.module">
                            <a-select-option key="classical" value="classical">
                                Klasikal
                            </a-select-option>
                            <a-select-option key="paper" value="paper">
                                Makalah
                            </a-select-option>
                            <a-select-option key="project" value="project">
                                Project Management
                            </a-select-option>
                            <a-select-option key="performance" value="performance">
                                Performance
                            </a-select-option>
                            <a-select-option key="evaluation" value="evaluation">
                                Evaluasi
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item label="Aspek">
                        <a-input v-model="formData.name"/>
                    </a-form-model-item>

                    <a-form-model-item label="Kode Singkat">
                        <a-input v-model="formData.short_code"/>
                    </a-form-model-item>

                    <a-form-model-item label="Kode">
                        <a-input v-model="formData.code"/>
                    </a-form-model-item>

                    <a-form-model-item>
                        <a-row type="flex" justify="center" align="top">
                            <a-col>
                                <a-space>
                                    <a-button
                                        type="primary"
                                        html-type="submit"
                                        :loading="processing"
                                        :disabled="processing"
                                        @click="handleSubmit"
                                        >Submit</a-button>
                                    <a-button
                                        @click="handleClose"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Tutup</a-button>
                                </a-space>
                            </a-col>
                        </a-row>
                    </a-form-model-item>
                </a-form-model>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        hash: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 10 },
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            formData: {
                type: 'aspect'
            }
        }
    },
    created() {
        if (this.editing) {
            this.preload = true
            this.getItem()
        }
    },
    computed: {
        editing() {
            return this.hash !== "";
        }
    },
    methods: {
        getItem() {
            this.$http
                .get(this.routeUri("api.category.show", {category: this.hash}))
                .then(response => this.formData = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.preload = false))
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.processing = true;

            let promise;

            if(!this.editing){
                promise = this.$http.post(
                    this.routeUri("api.category.store"),
                    this.formData
                );
            }else{
                promise = this.$http.put(
                    this.routeUri("api.category.update", {category: this.hash}),
                    this.formData
                );
            }

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            this.$emit("handleClose", true);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
    }
}
</script>